module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "tools"
    }
  }, [_vm._v("\n    Operations offline\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('a', {
    staticClass: "btn add btn-full",
    attrs: {
      "id": "main-action",
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.sync
    }
  }, [_c('i', {
    staticClass: "icon-go"
  }), _vm._v(" "), _c('strong', [_vm._v("Synchroniser")])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content list wrap",
    attrs: {
      "id": "list-offline"
    }
  }, _vm._l((_vm.actions), function(action) {
    return _c('div', {
      key: action.id
    }, [_c('p', [_c('i', {
      class: action.action === 'add' ? 'icon-add' : 'icon-edit'
    }), _vm._v("\n                " + _vm._s(action.type) + " "), _c('strong', [_vm._v(_vm._s(action.id))])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bcf5761","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/OfflineActions.vue
// module id = 741
// module chunks = 0